import { dispatch } from 'store';
import { USER_DAC7_ACTION_TYPE } from 'store/action-types/user-dac7.action-types';
import { IBusinessEntityData, IPrivatePersonData, UserAccountType } from 'types/user.types';

export const USER_DAC7_ACTION = {
  setAccountType: (accountType: UserAccountType) =>
    dispatch({
      type: USER_DAC7_ACTION_TYPE.SET_ACCOUNT_TYPE,
      payload: accountType,
    }),
  setInformation: (field: keyof IBusinessEntityData | keyof IPrivatePersonData, value: string) =>
    dispatch({
      type: USER_DAC7_ACTION_TYPE.SET_INFORMATION,
      payload: { field, value },
    }),
  setRequiredError: (field: keyof IBusinessEntityData | keyof IPrivatePersonData) =>
    dispatch({
      type: USER_DAC7_ACTION_TYPE.SET_REQUIRED_ERROR,
      payload: field,
    }),
  setConditionallyRequiredError: (field: keyof IBusinessEntityData | keyof IPrivatePersonData) =>
    dispatch({
      type: USER_DAC7_ACTION_TYPE.SET_CONDITIONALLY_REQUIRED_ERROR,
      payload: field,
    }),
  setInvalidValueError: (field: keyof IBusinessEntityData | keyof IPrivatePersonData) =>
    dispatch({
      type: USER_DAC7_ACTION_TYPE.SET_INVALID_VALUE_ERROR,
      payload: field,
    }),
  clearError: (field: keyof IBusinessEntityData | keyof IPrivatePersonData) =>
    dispatch({
      type: USER_DAC7_ACTION_TYPE.CLEAR_ERROR,
      payload: field,
    }),
  validateForm: () =>
    dispatch({
      type: USER_DAC7_ACTION_TYPE.VALIDATE_FORM,
    }),
  openConfirmation: () =>
    dispatch({
      type: USER_DAC7_ACTION_TYPE.OPEN_CONFIRMATION,
    }),
  cancelConfirmation: () =>
    dispatch({
      type: USER_DAC7_ACTION_TYPE.CANCEL_CONFIRMATION,
    }),
  submitConfirmation: () =>
    dispatch({
      type: USER_DAC7_ACTION_TYPE.SUBMIT_CONFIRMATION,
    }),
  prefillForm: () =>
    dispatch({
      type: USER_DAC7_ACTION_TYPE.PREFILL_FORM_WITH_SUBMITTED_DATA,
    }),
  setFormSubmitted: () =>
    dispatch({
      type: USER_DAC7_ACTION_TYPE.SET_FORM_SUBMITTED,
    }),
};
